export const AUTH_CONFIG = {
  // Proactive refresh grace periods (state-of-the-art defaults)
  // Refresh access token if it will expire within this window
  accessTokenRefreshThresholdMs: 2 * 60 * 1000, // 2 minutes
  // Refresh refresh-token if it will expire within this window
  refreshTokenRefreshThresholdMs: 5 * 60 * 1000, // 5 minutes

  // Background token validation interval used by AuthContext
  refreshCheckIntervalMs: 60 * 1000, // 1 minute

  // Navigation defaults
  defaultFallbackPath: '/login',
  defaultHomePath: '/',
} as const;

export type AuthConfig = typeof AUTH_CONFIG;


